import { visionURL } from "../../config/environment";
import JsonApiService from "../../services/jsonapiService";
import Jsona from "jsona";
import { useDispatch } from "react-redux";
import {
  clearUserAssignments,
  fetchUserAssignmentsListSuccess,
  updateUserAssignmentSuccess
} from "../../redux/actions/userAssignmentsListActions";
import normalize from "../../redux/utils/normalize";
import visionCallService from "../../services/visionCallService";

const dataFormatter = new Jsona();

const coursesApiService = async () => {
  return new JsonApiService("library_searches", {
    baseUrl: `${visionURL}/learning_center/api`,
    credentials: "include"
  });
};

/**
 * Retrieves the items related to a course's pending assignment
 */
export const useLibrarySearch = () => {
  const dispatch = useDispatch();
  const searchCourses = async ({ sortBy, page, filters }) => {
    const service = await coursesApiService();
    dispatch(clearUserAssignments());
    const response = await service
      .page(page)
      .sort(sortBy)
      .where(filters)
      .all()
      .then(response => response.json());
    dispatch(fetchUserAssignmentsListSuccess(normalize(response)));
    return {
      data: dataFormatter.deserialize(response),
      ...response.meta
    };
  };

  // TODO: Refactor this to use an operations endpoint to create multiple user assignments at once
  const createUserAssignments = async trainingObjectIds => {
    const service = await coursesApiService();
    const response = await service
      .create(
        visionCallService.serializeRequestBody(
          { trainingObjectIds },
          "userAssignment"
        )
      )
      .then(response => response.json());
    dispatch(updateUserAssignmentSuccess(normalize(response)));
    return response;
  };

  return { searchCourses, createUserAssignments };
};
